import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Redirect } from 'react-router-dom'
import { localize, getLocale } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import Card from '@material-ui/core/Card'
import NgrxAuth from '../../auth/Auth'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { updateClaim } from '../../redux/actions/submitAClaimActions'
import { submitAgain } from '../../redux/actions/submitNavigationActions'

class Welcome extends Component {
  componentDidMount () {
    this.props.updateUrl('https://www.youtube.com/embed/gh6GKsIknuo')
    this.props.setNext('terms')
    this.props.setPercent(0)
    if (window.localStorage.getItem('username')) { // If active session only
      // authToken
      if (window.localStorage.isWelcomePageShown) {
        this.props.submitAgain()
      } else {
        window.localStorage.setItem('isWelcomePageShown', true)
      }
    }
  }

  render () {
    if (!NgrxAuth.canSubmitClaim) {
      return <Redirect to={'Claims'} />
    }
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    const { content = '' } = contentItemText[loc] || {}
    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>
            <div dangerouslySetInnerHTML={{ __html: content }}/>
            <Row center='xs'>
              <Col xs={12} sm={8} md={4} lg={3}>
                <br /><br />
                <RBButton fullWidth label={localize('pages.SubmitAClaim.GetStartedButton')} primary variant='contained' onClick={() => this.props.goNext()} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    )
  }
}
function mapStateToProps (state) {
  return {
    memberSummary: state.memberSummaryReducer.memberSummary
  }
}

const ConnectedWelcome = connect(mapStateToProps, { push, updateClaim, submitAgain })(injectIntl(Welcome))
export default ConnectedWelcome



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/Welcome.js